import React from 'react';
import WelcomeImage from '../../assets/plus_icon/welcome.png';
import { ReactComponent as RightArrowIcon } from '../../assets/icons/rightarrow.svg';
import companyLogoIcon from '../../assets/plus_icon/company_logo.png';
import ramaLogo from '../../assets/plus_icon/rama_logo.png'
import { ReactComponent as LogoIcon } from '../../assets/logo.svg';
import SVWelcomeImage from '../../assets/plus_icon/sv_welcome.png'
import SVWelcomeMobile from '../../assets/plus_icon/mobile_welcome.png';
import SVWelcomeDesktop from '../../assets/plus_icon/desktop_welcom.png'
import buildifyLogo from '../../assets/plus_icon/Buildyfy-Logo-png.png';
import DesktopImage from '../../assets/plus_icon/desktop-banner.jpg';
import MobileImage from '../../assets/plus_icon/mobile-banner.jpg';
import TabBanner from '../../assets/plus_icon/Tab-banner.jpg';

const WelcomePage = ({ setChannelPartner }) => {
    return (
        <>
            {/* Desktop */}
            <figure className='hidden xl:block'>
                <img src={DesktopImage} className='' />
            </figure>
            {/* Tablet */}
            <figure className='hidden sm:block xl:hidden'>
                <img src={TabBanner} className='' />
            </figure>
            {/* Mobile */}
            <figure className='sm:hidden'>
                <img src={MobileImage} className='w-full' />
            </figure>
            <div className=''>
                <div className='flex items-center justify-center !my-10'>
                    {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                    <figure className='m-0 h-[62px] sm:h-[90px]  w-[228px]'>
                        <img src={buildifyLogo} alt="" className='h-100 w-full object-contain' />
                    </figure>
                    <div className='border-r-2 border-[#CFD5DE] h-[80px] sm:h-[100px] !ml-7 !mr-12'></div>
                    <div className=''>
                        {/* <span className='text-xl sm:text-[34px] font-bold italic'>propacity</span> */}
                        <LogoIcon className='sm:w-[200px] sm:h-[90px] w-[130px] h-[62px] ' />
                        {/* <span className='text-xs sm:text-base !mt-3'>Powered By Propacity</span> */}
                    </div>
                    {/* <span className='w-[145px] border-t-2 border-[#696969]'></span> */}
                </div>
                <div className='flex items-center justify-center w-full absolute left-0 bottom-6'>
                    <button className='text-white text-lg sm:text-2xl bg-gradient-to-r from-[#6D4DFF] to-[#06F] py-2 sm:py-3.5 w-[95%] sm:w-[396px] rounded-xl flex items-center justify-center'
                        onClick={() => setChannelPartner('2')}
                    >
                        Get Started
                        <span className='!ml-4 '>
                            <RightArrowIcon className='fill-white !w-6' />
                        </span>
                    </button>
                </div>
            </div>
        </>
    )
}

export default WelcomePage